import { provideWidgetClass } from "scrivito"

export const LightDarkImageWidget = provideWidgetClass("LightDarkImageWidget", {
  attributes: {
    lightImage: ["reference", { only: "Image" }],
    darkImage: ["reference", { only: "Image" }],
    alignment: ["enum", { values: ["left", "center", "right"] }],
    alternativeText: "string",
    height: "string",
    link: "link",
    objectFit: ["enum", { values: ["cover", "contain"] }],
    roundCorners: "boolean",
    width: "string"
  }
})

export type LightDarkImageWidgetInstance = InstanceType<
  typeof LightDarkImageWidget
>
